import styled, { css } from 'styled-components';

import { ReactComponent as CalendarIcon } from '../../../../assets/images/blueTheme/calendarIcon.svg';
import { StyledContentWrapper, StyledError, StyledMaxInput, StyledMinInput } from '../MinMaxFilter/styled';

const styledInput = css`
  max-width: 135px;

  &:active,
  &:focus-visible,
  &:focus {
    border: 1px solid ${({ theme }): string => `${theme.admanColors!.gray.light.fg1[0]}`} !important;
    box-shadow: 0 0 0 2px ${({ theme }): string => `${theme.colors!.colorWhite}`},
      0 0 0 4px ${({ theme }): string => `${theme.admanColors!.blue.dark.bg1[0]}`};
  }

  &:focus-visible {
    border: 1px solid ${({ theme }): string => `${theme.admanColors!.gray.light.fg1[0]}`};
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }): string => `${theme.colors!.colorWhite}`},
      0 0 0 4px ${({ theme }): string => `${theme.admanColors!.blue.dark.bg1[0]}`};
  }
`;

export const StyledDateInput = styled(StyledMinInput)`
  ${styledInput}
`;

export const StyledEndDateInput = styled(StyledMaxInput)`
  ${styledInput}
`;

export const StyledDateFieldsWrapper = styled(StyledContentWrapper)(
  ({ theme: { spacers } }) => css`
    padding-bottom: ${spacers!.spacer01};
  `
);

export const StyledCalendarIcon = styled(CalendarIcon)`
  position: absolute;
  right: 10px;
  top: 12px;
  z-index: 3;
`;

export const StyledErrorText = styled(StyledError)(
  ({ theme: { spacers } }) => css`
    padding-top: ${spacers!.spacer01};
    max-width: 280px;
    text-transform: none;
  `
);
